import { ca } from '@cian/analytics';

export function trackTellRealtorClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Click',
    label: 'why_rieltor/tell',
  });
}

export function trackChoseRealtorClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Click',
    label: 'why_rieltor/choose',
  });
}
